import App from 'app/app.js';

var LocaleESUSConfig = function ($provide) {
  var PLURAL_CATEGORY = { ZERO: 'zero', ONE: 'one', TWO: 'two', FEW: 'few', MANY: 'many', OTHER: 'other' };

  $provide.value('$localeESUS', {
    DATETIME_FORMATS: {
      AMPMS: ['AM', 'PM'],
      DAY: ['domingo', 'lunes', 'martes', 'mi\u00e9rcoles', 'jueves', 'viernes', 's\u00e1bado'],
      MONTH: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ],
      SHORTDAY: ['dom.', 'lun.', 'mar.', 'mi\u00e9.', 'jue.', 'vie.', 's\u00e1b.'],
      SHORTMONTH: ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sept.', 'oct.', 'nov.', 'dic.'],
      fullDate: "EEEE, d 'de' MMMM 'de' y",
      longDate: "d 'de' MMMM 'de' y",
      medium: 'MMM d, y h:mm:ss a',
      mediumDate: 'MMM d, y',
      mediumTime: 'h:mm:ss a',
      short: 'M/d/yy h:mm a',
      shortDate: 'M/d/yy',
      shortTime: 'h:mm a'
    },
    NUMBER_FORMATS: {
      CURRENCY_SYM: '$',
      DECIMAL_SEP: ',',
      GROUP_SEP: '.',
      PATTERNS: [
        { gSize: 3, lgSize: 3, maxFrac: 3, minFrac: 0, minInt: 1, negPre: '-', negSuf: '', posPre: '', posSuf: '' },
        {
          gSize: 3,
          lgSize: 3,
          maxFrac: 2,
          minFrac: 2,
          minInt: 1,
          negPre: '-',
          negSuf: '\u00a0\u00a4',
          posPre: '',
          posSuf: '\u00a0\u00a4'
        }
      ]
    },
    id: 'es-us',
    pluralCat: function (n, opt_precision) {
      if (n === 1) {
        return PLURAL_CATEGORY.ONE;
      }
      return PLURAL_CATEGORY.OTHER;
    }
  });
};

App.config(['$provide', LocaleESUSConfig]);
